export const DocsSiteSegment = 'docs-site';

export const SharedSegment = 'shared';

export const OldDocsSitePrefix = 'project-';

export const OldSharedPrefix = 'shared-';

export const OldSharedSegment = 's';

export const OldSharedAuthSegment = 'auth';

export const OldAuthPrefix = 'auth-shared-';
